import { render, staticRenderFns } from "./RequisitesForm.vue?vue&type=template&id=494d8f36&scoped=true&"
import script from "./RequisitesForm.vue?vue&type=script&lang=js&"
export * from "./RequisitesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d8f36",
  null
  
)

export default component.exports